import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumb } from "antd";
import { useLocation, Link } from "react-router-dom";
const toTruncatedLabel = (label) => {
    if (!label || label.length <= 20)
        return label;
    return `${label.slice(0, 20)}...`;
};
const Breadcrumbs = ({ items = [] }) => {
    const location = useLocation();
    if (items.length === 0)
        return null;
    return (_jsx(Breadcrumb, { children: items.map(({ label, link }) => (_jsx(Breadcrumb.Item, { children: link ? (_jsx(Link, { to: `${link}${location.search || ""}`, children: toTruncatedLabel(label) })) : (toTruncatedLabel(label)) }, `${link}_${label}`))) }));
};
export default Breadcrumbs;
